import type { ReturnInterface } from "@dealer-center/ddc-pages-dashboard-interface";
export interface TreeData {
  label: string;
  id: string;
  children?: TreeData[];
  dealer: DealerAndId;
}
export interface DealerAndId extends Dealer {
  id: string;
}
export interface Dealer {
  name?: string;
  url?: string;
  phone?: string;
  email?: string;
  status: string;
  Children?: Record<string, Dealer>;
}

export const convertDealerGroupToTreeData = (
  dealerGroup?: ReturnInterface[],
  parentId?: string
): TreeData[] => {
  const treeData: TreeData[] = [];
  if (!dealerGroup || dealerGroup.length === 0) {
    return treeData;
  }
  dealerGroup.forEach((dealer, key) => {
    const id = `${parentId ? `${parentId}-` : ""}${dealer.id}`;
    const children = convertDealerGroupToTreeData(dealer.children, id);
    const treeItem: TreeData = {
      id,
      label: dealer.name || "Unknown Company",
      children,
      dealer
    };
    treeData.push(treeItem);
  });
  return treeData;
};

const csvHeader = "ID,Name,Email,Phone,Status,URL,Parent\n";
export const convertToCSV = (data: ReturnInterface[], parent = ""): string => {
  let csv = parent === "" ? csvHeader : "";
  data.forEach(item => {
    csv += `${item.id},${item.name},${item.email},${item.phone},${item.status},${item.url},${parent}\n`;
    if (item.children) {
      csv += convertToCSV(item.children, item.id);
    }
  });
  return csv;
};

export const getEveryId = (
  data: ReturnInterface[],
  parentId = ""
): string[] => {
  const ids: string[] = [];

  data.forEach(item => {
    const id = parentId ? `${parentId}-${item.id}` : item.id;
    ids.push(id);
    if (item.children) {
      ids.push(...getEveryId(item.children, id));
    }
  });

  return ids;
};

export const findAccount = (
  accountIdToFind: string,
  parentIds: string[],
  data: ReturnInterface[] | undefined
): string[] | null => {
  if (!data) {
    return null;
  }

  for (const item of data) {
    const lastParentId: string | undefined = parentIds[parentIds.length - 1];
    const parentIdWithPath = lastParentId
      ? `${lastParentId}-${item.id}`
      : item.id;
    if (item.id === accountIdToFind) {
      return [...parentIds, parentIdWithPath];
    }

    const newParentIds = [...parentIds, parentIdWithPath];
    const foundItem = findAccount(accountIdToFind, newParentIds, item.children);
    if (foundItem) {
      return foundItem;
    }
  }

  return null;
};
